import { defineComponent } from 'vue'
import { SvgIcon } from './SvgIcon'

const CheckBox = defineComponent({
  props: {
    label: { type: String, required: true },
    active: { type: Boolean, default: false },
    value: { type: String, required: true },
  },
  emits: { select: (_value: string) => true },
  setup (props, { emit }) {
    return () => (
      <div
        class={`
          flex items-center transition font-semibold 
          rounded-sm border cursor-pointer py-3
          ${
            props.active
              ? 'border-deep-green-700 text-deep-green-700 bg-light-primary'
              : 'border-gray-100 text-gray-600'
          }
        `}
        onClick={() => emit('select', props.value)}
      >
        <div
          class={`
            shrink-0
            w-[18px] h-[18px] ml-3 rounded-full border 
            text-white
            transition
            flex items-center justify-center
            ${
              props.active
                ? 'border-deep-green-700 bg-deep-green-700'
                : 'border-gray-100'
            }
          `}
        >
          {props.active
            ? (
            <SvgIcon name="check" class="animate-fade-in" size="80%" />
              )
            : null}
        </div>
        <div class="px-2 grow">{props.label}</div>
      </div>
    )
  },
})

export default CheckBox
